import "../styles/NotFound.css";

export default function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img
          src="../assets/404pipetest2.svg"
          alt="404 Not Found"
          className="not-found-image"
        />
        <h3 className="not-found-title">You Found a Busted Pipe!</h3>
        <p className="not-found-message">
          The page you dug up is under repair. Please check the blueprints or
          return home.
        </p>

        <button
          className="not-found-button"
          onClick={() => (window.location.href = "/")}
        >
          Return Home
        </button>
      </div>
    </div>
  );
}
